export namespace LocationClassConstants {
    export enum LocationClass {
		BASIC = 'BASIC',
		CCSG = 'CCSG',
    }
}
  